import React from 'react';
import ReceivePaymentsForm from '../../components/organisms/ReceivePaymentsForm';

const ReceivePayment = () => <ReceivePaymentsForm />;

export default React.memo(ReceivePayment);
